import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-date",
  "use": "icon-date-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-date\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 14H14V2H10.6667H10C9.5586 3.05285 8.89193 3.57927 8 3.57927C7.10807 3.57927 6.4414 3.05285 6 2H5.33333H2V14Z\" stroke=\"#F0C78A\" stroke-linejoin=\"round\" />\n<path d=\"M5 8L7 10L11 6\" stroke=\"#F0C78A\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol